import './_Input.scss'

/**
 * @component Input
 * @param {object} params
 * @param {string} params.value
 * @param {string} params.placeholder
 * @param {function} params.setValue
 * @param {boolean} params.error
 * @param {string} params.errorMessage
 */

const Input = ({
  value, setValue, placeholder,
  error, errorMessage
}) => {
  return (
    <div className='InputBox'>
      <input
        className={`Input ${error ? 'error' : ''}`}
        value={value}
        placeholder={placeholder}
        onChange={e => setValue(e.target.value)}
      />
      { !errorMessage || <span className='error-msg'>{errorMessage}</span> }
    </div>
  )
}

export default Input
